<template>
  <main-layout>
    <template v-if="isMobile">
      <livechat-mobile></livechat-mobile>
    </template>
    <template v-else>
      <livechat></livechat>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Livechat from './Livechat'
import LivechatMobile from './LivechatMobile'
export default {
  data: () => ({
    isMobile: false
  }),
  components: {
    Livechat,
    LivechatMobile
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeMount: function() {
    // if (
    //   this.selectedBot.pagetype != 'enterprise' ||
    //   !this.$store.state.livechatPageList.includes(this.selectedBot.theme)
    // ) {
    //   this.$router.push('/' + this.$store.getters.currentLang + '/dashboard')
    // }
  },

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 960
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatView.vue